// see: https://ja.react.dev/learn/scaling-up-with-reducer-and-context

import PropTypes from 'prop-types'
import { createContext, useContext, useReducer } from 'react'

/** @type {import('react').Context<ReturnType<getInitialState>>} */
const DashboardContext = createContext(null)
const DashboardDispatchContext = createContext(null)

export const useDashboard = () => {
    return useContext(DashboardContext)
}

export const useDashboardDispatch = () => {
    return useContext(DashboardDispatchContext)
}

export const DashboardProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, null, getInitialState)
    // console.log({ state })
    return (
        <DashboardContext.Provider value={state}>
            <DashboardDispatchContext.Provider value={dispatch}>
                {children}
            </DashboardDispatchContext.Provider>
        </DashboardContext.Provider>
    )
}
DashboardProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'RESISTER': {
            return {
                ...state,
                modal: action.payload ? 'resister' : '',
            }
        }
        case 'CONFIRM': {
            const { sfId, next } = action.payload
            return {
                ...state,
                sfId,
                next,
                modal: sfId ? 'confirm' : '',
            }
        }
        case 'DONE': {
            const { sfId, next } = action.payload
            return {
                ...state,
                sfId,
                next,
                modal: sfId ? 'done' : '',
            }
        }
    }
    throw Error('Unknown action.')
}

const getInitialState = () => {
    return {
        sfId: '',
        modal: '',
        next: '',
    }
}
